import React, { useRef, useState } from 'react';
import { getAvailableOrderUsers, getLocalUTCDateTimestamp } from '../../helpers';

import { useDispatch, useSelector } from 'react-redux';
import { orderStatuses } from '../../names';
import { Select } from '../../components/Select';
import { Input } from '../../components/Input';
import { Popup } from '../../components/Popup';
import { Button } from '../../components/Button';
import { completeOrder } from '../../redux/orderSlice';

function isValidSum(str) {
    if (str === '' || isNaN(+str) || +str > 10_000_000) {
        return false;
    }
    return true;
}

export const FinishOrderPopup = ({ order, closeFn }) => {
    const dispatch = useDispatch();

    const statuses = useSelector((state) => state.settings.orderStatuses);
    const finishingStatuses = statuses
        .filter(
            (status) =>
                status.name === orderStatuses.DONE ||
                status.name === orderStatuses.MODERN ||
                status.name === orderStatuses.CANCEL,
        )
        .reverse();

    const botTelegramId = useSelector((state) => state.settings.botTelegramId);
    const orderUserIds = useSelector((state) => state.settings.orderUsers);
    const orderUsers = useSelector((state) => state.users.list).filter((u) =>
        orderUserIds.some((u2) => u2 === u._id),
    );
    const availableOrderUsers = [{_id: '', fullname: 'Без мастера (кроме модернов)'},...getAvailableOrderUsers(
        orderUsers,
        order.city,
        order.profileType,
        botTelegramId,
    )];

    const [status, setStatus] = useState(finishingStatuses[0]._id);

    const isDone = status === statuses.find((st) => st.name === orderStatuses.DONE)._id;
    const isModern = status === statuses.find((st) => st.name === orderStatuses.MODERN)._id;

    const [totalAmount, setTotalAmount] = useState('');
    const [partsCost, setPartsCost] = useState('');

    const [worker, setWorker] = useState(availableOrderUsers.length ? availableOrderUsers[0]._id : '');
    const [prepayment, setPrepayment] = useState('');
    const [nextWorkDate, setNextWorkDate] = useState('');

    const [workerComment, setWorkerComment] = useState('');
    const [completionDate, setCompletionDate] = useState('');

    const [bso, setBso] = useState([]);
    const [cheque, setCheque] = useState([]);

    const bsoInputRef = useRef(null);
    const chequeInputRef = useRef(null);
    const clickInputHandler = (ref) => {
        ref.current.click()
    }
    const setFilesHandler = (e, fn) => {
        const selectedFiles = Array.from(e.target.files);
        fn(selectedFiles);
    };

    const finishButtonHandler = () => {
        if (
            isDone &&
            (!isValidSum(totalAmount) || !isValidSum(partsCost) || +totalAmount < +partsCost)
        ) {
            return;
        }
        if (isModern && (!isValidSum(prepayment) || nextWorkDate === '')) {
            return;
        }
        const completeType = isDone ? 'done' : isModern ? 'modern' : 'cancel';
        const cityUTC = order.city.UTC;
        const formattedDate = completionDate ? getLocalUTCDateTimestamp(cityUTC, completionDate) : null;
        dispatch(
            completeOrder({
                completeType,
                orderData: {
                    _id: order._id,
                    ...(isDone
                        ? { totalAmount: +totalAmount, partsCost: +partsCost, bso, cheque }
                        : isModern
                        ? { prepayment: +prepayment, nextWorkDate }
                        : {}),
                    ...(workerComment ? { workerComment } : {}),
                    ...(completionDate ? { completionDate: formattedDate } : {}),
                    ...(worker ? {worker} : {})
                },
                closeFn,
            }),
        );
    };

    return (
        <Popup
            title={`Закрыть заявку id${order.id}`}
            closeFn={closeFn}
            button={<Button text="Закрыть заявку" onClick={finishButtonHandler} />}>
            <div className="finish-order">
                <div className="finish-order__option">
                    <Select
                        enums={finishingStatuses}
                        value={status}
                        className="cell"
                        label="Закрыть как"
                        changeHandler={(evt) => setStatus(evt.target.value)}
                    />
                </div>
                {isDone && (
                    <>
                        <div className="finish-order__option">
                            <Input
                                className="cell"
                                placeholder="Общая"
                                label="Общая"
                                value={totalAmount}
                                changeHandler={(evt) => setTotalAmount(evt.target.value)}
                            />
                        </div>
                        <div className="finish-order__option">
                            <Input
                                className="cell"
                                placeholder="Введите 0, если нет"
                                label="ЗПЧ"
                                value={partsCost}
                                changeHandler={(evt) => setPartsCost(evt.target.value)}
                            />
                        </div>
                        <div className="finish-order__option" style={{display: 'flex', alignItems: 'flex-end'}}>
                            <input accept=".jpg,.jpeg,.png" style={{display: 'none'}} ref={bsoInputRef} type='file'  multiple={true} onChange={(e) => setFilesHandler(e, setBso)}/>
                            <Button text={!bso.length ? 'выбрать фото бсо' : `выбрано ${bso.length} фото`} onClick={() => clickInputHandler(bsoInputRef)} />
                        </div>
                        <div className="finish-order__option" style={{display: 'flex', alignItems: 'flex-end'}}>
                            <input accept=".jpg,.jpeg,.png" style={{display: 'none'}} ref={chequeInputRef} type='file'  multiple={true} onChange={(e) => setFilesHandler(e, setCheque)}/>
                            <Button text={!cheque.length ? 'выбрать фото чеков' : `выбрано ${cheque.length} фото`} onClick={() => clickInputHandler(chequeInputRef)} />
                        </div>
                    </>
                )}
                {isModern && (
                    <>
                        <div className="finish-order__option">
                            <Input
                                className="cell"
                                placeholder="Предоплата"
                                label="Предоплата"
                                value={prepayment}
                                changeHandler={(evt) => setPrepayment(evt.target.value)}
                            />
                        </div>
                        <div className="finish-order__option">
                            <Input
                                className="cell"
                                placeholder="Дата в свободной форме"
                                label="Когда завершит модерн"
                                value={nextWorkDate}
                                changeHandler={(evt) => setNextWorkDate(evt.target.value)}
                            />
                        </div>
                    </>
                )}
                {!order.worker && (
                    <div className="finish-order__option">
                        <Select
                            enums={availableOrderUsers}
                            value={worker}
                            className="cell"
                            label="Закрыть заявку на"
                            changeHandler={(evt) => setWorker(evt.target.value)}
                        />
                    </div>
                )}
                <div className="finish-order__option">
                    <Input
                        className="cell"
                        placeholder="(необязательно)"
                        label="Коммент мастера"
                        value={workerComment}
                        changeHandler={(evt) => setWorkerComment(evt.target.value)}
                    />
                </div>
                <div className="finish-order__option">
                    <Input
                        type='datetime-local'
                        className="cell"
                        label={`Когда закрыл${isModern ? ' в модерн':''}`}
                        value={completionDate}
                        changeHandler={(evt) => setCompletionDate(evt.target.value)}
                    />
                </div>
            </div>
        </Popup>
    );
};
